<template>
  <div class="time-range">
		<el-radio-group @change="timeRangeChange" v-model="timeRange">
                  <el-radio-button :label="0">不限</el-radio-button>
                  <el-radio-button :label="1">今年</el-radio-button>
                  <el-radio-button :label="2">本月</el-radio-button>
                  <el-radio-button :label="3">自定义</el-radio-button>
                </el-radio-group>
                <el-date-picker @change="timeRangeNumChange" v-model="timeRangeNum"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd">
                </el-date-picker>
	</div>
</template>

<script>
import moment from 'moment'
export default {
	data(){
		return{
			timeRange:0,
			timeRangeNum:'',
			endTime:'',
			startTime:''
		}
	},
	methods:{
		timeRangeChange() {
      this.timeRangeNum = null
      if (this.timeRange !== 3) {
        let day = moment()
        if (this.timeRange === 0) {
          this.startTime =''
          this.endTime = this.startTime
        } else if(this.timeRange === 2){
          this.startTime =day.years()+'-'+ (day.months()+1) +'-01'
					this.endTime = moment(this.startTime, 'YYYY-MM-DD').add(day.daysInMonth()-1,'days').format("YYYY-MM-DD")
        } else{
          this.startTime = day.years() + '-01-01'
          this.endTime = day.years() + '-12-31'
        }
			}
			this.$emit('timeRangeChange', {startTime:this.startTime,endTime:this.endTime})
    },
    //时间段日期选择框改变
    timeRangeNumChange() {
      this.timeRange = '3'
      if (this.timeRangeNum) {
        this.startTime = this.timeRangeNum[0]
        this.endTime = this.timeRangeNum[1]
        this.$emit('timeRangeChange', {startTime:this.startTime,endTime:this.endTime})
      }
    },
	}
}
</script>

<style lang="scss">
.time-range{

}
</style>
